import VideoCamera from './src/video-camera-combined';
export default VideoCamera;